import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import {MdAdd, MdRemove} from 'react-icons/md';
// import {TiHeartOutline, TiHeartFullOutline} from 'react-icons/ti';
import CircularProgressbar from 'react-circular-progressbar';
import Rating from 'react-star-rating-component';
import {RESPONSE_STATUS } from '../../utils/constants';
import ReactGA from 'react-ga';
import ContentEditable from 'react-contenteditable';
import ScrollArea from 'react-scrollbar';
import { isMobile } from '../../utils/util';
import './Product.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Api from '../../utils/api';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const descriptionStyle = {
    fontSize: '11px',
    lineHeight: '1.4',
    letterSpacing: '0px',
    color: '#060000',
    textAlign: 'justify',
    marginTop: '28px',
    width: '100%'
};

const brandTxtLg = {
    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    fontWeight: '500',
    letterSpacing: '0.3px',
    color: '#272d67',
    lineHeight: 'normal',
    whiteSpace: 'pre-line',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight:  !localStorage.getItem("auth_token") ? '0' : '52px',
};

const txtLg = {
    fontFamily: 'Montserrat',
    fontSize: '11.2px',
    letterSpacing: '0.3px',
    fontWeight: '600',
    color: '#272d67',
    lineHeight: 'normal',
};

// let prevCount = 0;
let currCount = 0;



class Product extends Component {

    constructor(props) {
        super(props);

        this.state = {
            count: 0,
            recReasonExpanded: false,
            descriptionExpanded: false,
            addedToCart: false,
            showProductDescription: false,
            showWhyIsItGood: true,
            heartFilled: props.product && props.product.wished ? true : false,
            rating: props.product && props.product.rating ? props.product.rating : 0,
            showReviewModal: false,
            productCart: props.productCart,
            defaultPurchase: false,
            editHtml: '',
            showWhyIsItGood: true
        };
    }

    componentDidMount() {
        const isNotFirstTime = localStorage.getItem("recohaspurchased");
        const localCart = localStorage.getItem("recommendations_cart_fetched_with_prod");
        // this.generateRecReason();
        // 第一次进去推荐产品页面，会把每一行的第一个产品加入购物车。现在这个功能删除
        // if (this.props.isFirstTime && this.props.index === 0) {
        //     this.setState({ addedToCart: true });
        // } else {
            if (/*(localCart && JSON.parse(localCart).some(product => product.id === this.props.product.id)) ||*/
                (this.state.productCart && this.state.productCart.some(product => product.id === this.props.product.id))) {
                this.setState({ addedToCart: true });
            } 
        // }
    }

    componentDidUpdate(prevProps) {
        if (this.props.productCart !== prevProps.productCart) {
            this.setState({ productCart: this.props.productCart }, () => {
                if ((this.state.productCart && this.state.productCart.some(product => product.id === this.props.product.id))) this.setState({ addedToCart: true });
                else this.setState({ addedToCart: false });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.cartGoodsList.map(product => product.id).includes(this.props.product.id)){
            this.setState({ addedToCart: true})
        }else {
            this.setState({ addedToCart: false})
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            (this.props.isFirstTime !== nextProps.isFirstTime) ||
            (this.props.isInProductCart !== nextProps.isInProductCart) ||
            (this.props.productCart !== nextProps.productCart) ||
            (this.state.addedToCart !== nextState.addedToCart) ||
            // (this.state.rating !== nextState.rating) ||
            (this.state.heartFilled !== nextState.heartFilled) ||
            (this.state.showProductDescription !== nextState.showProductDescription) ||
            (this.state.showWhyIsItGood !== nextState.showWhyIsItGood)
        );
    }


    generateProductName = () => {
        let name = this.props.product.name;
        let vendor = this.props.product.vendor;
        if (name.indexOf(vendor) > -1) {
            return name.replace(vendor, '');
        }
        return name;
    }

    generateRecReason = () => {
        let recReasonListItemsStr = [];
        const reg = /<[a-z][\s\S]*>/i.test(this.props.product.recReason);
        if (!reg && this.props.product.recReason ) {
            this.props.product.recReason.split(".").filter(str => { return str !== "" }).forEach((sentence, index, arr) => {
                const isDontKnow = sentence.toLowerCase().includes("dont know");
                if (!isDontKnow) recReasonListItemsStr.push(<li key={index}>{ sentence.toString().replace("$", "").replace(",","").replace(/,/g, '').trim()  + "." }</li>)
            });
            // let recReasonOutputStr = `<ul>${ recReasonListItemsStr.toString().replace(",","").replace(/,/g, '').trim() }</ul>`;
            // this.setState({ editHtml: recReasonOutputStr });
            return recReasonListItemsStr;
        } else {
            // this.setState({ editHtml: this.props.product.recReason });
            return this.props.product.recReason;
        }
    }

    generateDescription = () => {
        // Strip HTML tags from description
        let div = document.createElement("div");
        div.classList.add("description-blurb");
        div.innerHTML = this.props.product.description;
        let text = div.textContent || div.innerText || "";
        text = text.replace(/<(?:.|\n)*?>/gm, '');

        return text;
    }

    generatePrice = () => {
        let price = this.props.product ? parseFloat(this.props.product.price).toFixed(2) : 0;
        return price;
    }

    toggleProductDescription = (e) => {
        e.preventDefault();
        // e.stopPropagation();
        this.setState({
            // showProductDescription: true,
            showWhyIsItGood: !this.state.showWhyIsItGood
        });

    }

    // toggleProductIngredients = (e) => {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     this.setState({
    //         showProductDescription: false,
    //         showWhyIsItGood: true
    //     });

	// 	}

    addToCartLabel = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if(this.props.product.inventory <= 0){
            alert('Out of stock');
            return false
        }else{
            let addedToCart = !this.state.addedToCart;
            this.setState({addedToCart: addedToCart}, () => {
                this.props.saveCartForLater(this.props.product);
            });
        }
    }


    handleHeartClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const userId = localStorage.getItem("user_id");
        const url = '/api/product-wishlists';
        const prodId = this.props.product.id;

        if (!this.state.heartFilled) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: true});
                    // if (process.env.REACT_APP_ENV === 'prod') {
                    //     ReactGA.event({
                    //         category: 'Heart Clicked',
                    //         action: "Click",
                    //         label: this.props.product.name,
                    //         value: 1
                    //     });
                    // }
                } else {
                    alert("There was a problem to saving the product to your wishlist. Please try again.");
                }
            });

        } else {
            fetch(url, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: false});
                    // if (process.env.REACT_APP_ENV === 'prod') {
                    //     ReactGA.event({
                    //         category: 'Heart Unclicked',
                    //         action: "Click",
                    //         label: this.props.product.name,
                    //         value: 1
                    //     });
                    // }
                } else {
                    alert("There was a problem removing the product from your wishlist. Please try again.");
                }
            });

        }
    }

    render() {
        const rating = this.state.rating;

        let DescriptionAndIngredients = styled.div`
        font-family: Montserrat, Helvetica, Arial, sans-serif;
        font-weight: 600;
        margin-bottom: 0.5em;
        display: flex;
        justify-content: space-around;
        width: 100%;

        .link {
            width: 100%;
            text-align: center;
            padding: 2% 3%;
            border-bottom: solid 1px #ffad94;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            a {
                font-size: 10.4px;
                border-bottom: none;
                color: #cdcdcd;
                white-space: nowrap;
            }

            &:hover,  {
                font-weight: 600;

                a:hover {
                    font-weight: 600;
                }
            }

            &.active {
                font-weight: 600;
                color: #ffad94;
                border: solid 1px #ffad94;
                border-bottom: none;

                &.left {
                    border-left: none;
                }

                &.right {
                    border-right: none;
                }

                a {
                    color: #ffad94;
                    border-bottom: solid 3px transparent;
                }
            }
        }
        `;

        let AddToCart = styled.div`
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        font-size: 12.2px;
        font-weight: 600;
        color: #272d67;
        flex-basis: 43%;
        `;

        let ProductImageHolder = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 0.5em 0;
        `;

        let ProductImage = styled.img`
        max-width: 300px;
        height: 237px;
        width: auto;
        `;

        let ProductInfo = styled.div`
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
        flex-wrap:wrap;
        position: relative;
        `;

        let ProductScore = styled.div`
        display: flex;
        flex-direction: column;
        `;

        let Price = styled.div`
        font-family: "Open Sans", Helvetica, Arial, sans-serif;
        font-size: 11.2px;
        letter-spacing: 0.3px;
        text-align: left;
        color: #272d67;
        font-weight: normal;
        line-height: 1.71;
        `;

        let WishListAndRating = styled.div`
        display: flex;
        justify-content: space-between;
        padding-top: 0.5em;
        margin-top: 0.5em;
        border-top: 1px solid #cdcdce;
        width: 100%;
        font-size: 10px !important;

        span.add-to-wishlist-heart {
            margin-left: 5px;
        }
        `;

        if (this.props.product) {
            return (
                <div style={{padding:'10px 2px'}}>
                    <div className={!this.state.addedToCart ? "product product-item" : "product product-item product-added"}  style={!localStorage.getItem("auth_token") ?  isMobile(navigator.userAgent) ? null :  {margin: 'auto' } : {} }   /*onClick={() => this.props.selectProduct(this.props.product)}*/ >
                    <a target={ isMobile(navigator.userAgent) ? "_self" : "_blank" } href={`/recommendations/products/${this.props.product.id}`}>
                        {
                        localStorage.getItem("auth_token") ?
                        <div className='ProductScore'>
                                {/* <div className="product-choice" style={ this.props.index == 0 ? {} :{visibility:"hidden"} }> */}
                                <div className="product-choice" style={{visibility:"hidden"} }>
                                    <div>
                                        <i className="fa fa-star choice-icon" ></i>
                                    </div>
                                    <div className="product-choice-text" >TOP CHOICE!</div>
                                </div>

                                <div className="product-score">
                                        <div className="product-score-label">
                                            <div className="number">{this.props.product.score}</div>
                                            <div className="matching-score">MATCH</div>
                                        </div>
                                </div>
                            </div> : null
                        }

                        <div className="image-holder ProductImageHolder product-img-area" >
                            <img alt={ this.props.product.name } title={this.props.product.name} data-src={ this.props.product.coverImageSource } className= "embeddedCoordinates lazyload product-img"/>
                        </div>
                        <div className="ProductInfo">
                            <div className="product-info">
                                <div className="brand" style={ brandTxtLg }>{ this.props.product.vendor }</div>
                                <div className="product-name" style={ !localStorage.getItem("auth_token") ?{width:'100%'} : null }>{ this.generateProductName() }</div>
                            </div>
                            {
                                localStorage.getItem("auto-token") ?
                                <span className="add-to-wishlist-heart" onClick={this.handleHeartClick}>
                                {this.state.heartFilled ?
                                    <i className="fa fa-heart" aria-hidden="true" style={{fontSize:'18px',color:'#272d67'}}/>
                                    : <i className="fa fa-heart-o" style={{fontSize:'18px',color:'#272d67'}} aria-hidden="true"/>
                                    }
                                </span>:null
                            }

                            <div className="product-info-bottom-price-button">
                            <div className="Price price">${ this.generatePrice() }</div>
                                <div className="button-holder AddToCart">
                                    <button className={!this.state.addedToCart ? "cart-button" : "cart-button addedButton"} onClick={this.addToCartLabel}>
                                    {
                                        !this.state.addedToCart ?
                                        "Add" :
                                        "Added"
                                    }
                                    <i className="cart-icon"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        {/* <div style={ descriptionStyle } >  No need for function*/}
    {/*                     
                        <div style={{display:"none"}} >
                            <DescriptionAndIngredients>
                                <div className={this.state.showWhyIsItGood ? "link active left" : "link left"} onClick={this.toggleProductDescription}>
                                </div>
                                <div className={!this.state.showWhyIsItGood ? "link active right" : "link right"} onClick={this.toggleProductDescription}>
                                    <a className="link-label">Description</a>
                                </div>
                            </DescriptionAndIngredients>
                            <div className="product-description" onClick={ (e) => {e.stopPropagation()} }>
                                {
                                    this.state.showWhyIsItGood ?

                                    <div>
                                        <ScrollArea
                                            speed={0.8}
                                            className="area"
                                            contentClassName="content"
                                            horizontal={false}
                                        >
                                        <ul>
                                        { this.generateRecReason() }
                                        </ul>
                                    <ContentEditable
                                            html={ this.state.editHtml }
                                            disabled={ true }
                                    />
                                        </ScrollArea>

                                    </div> :
                                    <div>

                                        <ScrollArea
                                            speed={0.8}
                                            className="area"
                                            contentClassName="content"
                                            horizontal={false}
                                        >
                                            <p>{ this.generateDescription() }</p>
                                        </ScrollArea>
                                    </div>

                                }
                            </div>
                            <WishListAndRating>
                                <div className="add-to-wishlist">
                                    <span className="add-to-wishlist-heart" onClick={this.handleHeartClick}>
                                        {this.state.heartFilled ? 
                                        <i className="fa fa-heart" aria-hidden="true" style={{fontSize:'18px'}}/>
                                        : <i className="fa fa-heart-o" style={{fontSize:'18px'}} aria-hidden="true"></i>}
                                    </span>
                                    wish list
                                </div>
                            </WishListAndRating>
                        </div> */}
                        </a>
                    </div>
                </div>
            );
        } else {
            return (<div className="product" style={{visibility:'hidden'}} />);
        }
    }
}

function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}
export default connect(mapStateToProps)(Product);



// WEBPACK FOOTER //
// ./src/components/product/Product.js